import ApiClient from '@/api/ApiClient';

import type {
  FilterCriteria,
  PagedResultUserHealthListItem,
  SortCriteria,
  UserCountStatistics,
} from '../models';

export type SearchUserHealthRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export type GetHrUserHealthStatisticsRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  groupBy?: string;
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export class HrHealthListClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  searchUserHealth(request: SearchUserHealthRequest = {}): Promise<PagedResultUserHealthListItem> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/health',
      params,
    });
  }

  getHrUserHealthStatistics(request: GetHrUserHealthStatisticsRequest = {}): Promise<UserCountStatistics[]> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/health/statistics',
      params,
    });
  }
}

export default HrHealthListClient;
